'use strict';

angular.module('fileUploadApp')
    .config(['$stateProvider',function ($stateProvider) {
        $stateProvider
            .state('fileUpload', {
                abstract: true,
                parent: 'app'
            })
            .state('fileUpload.fileManager', {
	            parent: 'fileUpload',
	            url: '/FileManager',
	            data: {
	                authorities: ['ROLE_USER'],
	                pageTitle: 'FileManager'
	            },
	            views: {
	                'content@': {
	                    templateUrl: 'app/entities/fileManager/fileUpload.html',
	                    controller: 'FileUploadController'
	                }
	            },
	            resolve: {
	            	 
	            }
            })
            .state('fileUpload.fileUpload', {
	            parent: 'fileUpload',
	            url: '/UploadFile',
	            data: {
	                authorities: ['ROLE_USER'],
	                pageTitle: 'FileManager'
	            },
	            views: {
	                'content@': {
	                    templateUrl: 'app/entities/fileManager/fileUpload.html',
	                    controller: 'FileUploadController'
	                }
	            },
	            resolve: {
	            	 
	            }
            });
        
    }]);
